import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

/** Staff — GET /notification-portal */
export const fetchNotificationsPortal = async (params = {}) => {
  const res = await axiosInstance.get("/notification-portal", { params });
  return res.data;
};

/** Staff — GET /notification-portal/unread-count */
export const fetchUnreadCountPortal = async () => {
  const res = await axiosInstance.get("/notification-portal/unread-count");
  return res.data;
};

/** Staff — PATCH /notification-portal/:id/read */
export const markNotificationReadPortal = async (id) => {
  const res = await axiosInstance.patch(`/notification-portal/${id}/read`);
  return res.data;
};

/** Staff — PATCH /notification-portal/read-all */
export const markAllNotificationsReadPortal = async () => {
  const res = await axiosInstance.patch("/notification-portal/read-all");
  return res.data;
};

/** Staff — DELETE /notification-portal/:id */
export const deleteNotificationPortal = async (id) => {
  const res = await axiosInstance.delete(`/notification-portal/${id}`);
  return res.data;
};
